export default "__VITE_ASSET__C9D5jeeI__"